module.exports = __webpack_public_path__ + "img/poi.a6292d9c.png";